"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSetting = exports.getSettings = exports.getSettingById = exports.deleteSetting = exports.defaultSettingData = exports.createSetting = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultSettingData = exports.defaultSettingData = {
  id: 0,
  bankInformation: '',
  quotationAdditionalNote: '',
  termsAndConditions: '',
  transportCharges: 0,
  packagingCharges: 0,
  automatedCreditNoteGenerationDays: 0,
  expiryDays: 0,
  bookingAmountThreshold: 0,
  transactionPercent: 0,
  bookingPercent: 0,
  cancellationCharges: 0,
  whatsappRecipients: [],
  workingHours: '',
  webVersion: '',
  supportEmail: '',
  supportContact: '',
  blacklistedEmailDomains: [],
  featuredProductPromoImage: '',
  featuredProductPromoName: '',
  featuredProductPromoLink: '',
  cartLimit: 0,
  nextQuotation: ''
};
const getSettings = params => (0, _request.default)({
  url: '/settings',
  method: 'get',
  params
});
exports.getSettings = getSettings;
const getSettingById = id => (0, _request.default)({
  url: `/settings/${id}`,
  method: 'get'
});
exports.getSettingById = getSettingById;
const updateSetting = (id, data) => (0, _request.default)({
  url: `/settings/${id}`,
  method: 'patch',
  data
});
exports.updateSetting = updateSetting;
const deleteSetting = id => (0, _request.default)({
  url: `/settings/${id}`,
  method: 'delete'
});
exports.deleteSetting = deleteSetting;
const createSetting = data => (0, _request.default)({
  url: '/settings/',
  method: 'post',
  data
});
exports.createSetting = createSetting;